import { decodePermissions } from '../../Shared/functions';
import React, {Component} from 'react';
import ClipLoader from "react-spinners/ClipLoader";
import Notification from '../../Shared/Notifications';
import { login } from './services/login';
import { 
    UserIcon, 
    LockClosedIcon, 
    EyeIcon, 
    EyeSlashIcon,
    BuildingOffice2Icon,
    ShieldCheckIcon 
} from '@heroicons/react/24/outline';

class Login extends Component {

    constructor(props){
        super(props)
        this.state = {
            email: '',
            password: '',
            notification: false,
            loading: false,
            showPassword: false,
        }
    }

    renderNotification = () => {
        return(
            <Notification 
                setShow={() => this.setState({notification:false})}
                type={'error'}
                show={this.state.notification}
                title={'Hubo un error iniciando sesion'}
                subtitle={'El usuario o la contraseña parecen ser incorrectos'}
            />
        )
    }

    login(){
        this.setState({loading:true})
        login({user:this.state.email,password:this.state.password}).then((result) => {
            if(result && result.status === 200 && result.data) {
                if(result.data.data.typeUser === 'SUPER USUARIO' 
                || result.data.data.typeUser === 'ANALISTA'
                || result.data.data.typeUser === 'WEB'
                ) {
                    if(!result.data.data.active) {
                        alert('Este usuario no se encuentra actualmente activo, por favor contacte al administrador')
                    }else{
                        const token = result.data.data.token;
                        // Los permisos pueden venir codificados con comilla simple (ver decodePermissions).
                        const permissions = decodePermissions(result.data.data.permissions);
                        const typeUser = result.data.data.typeUser;
                        const userName = result.data.data.userName;
                        window.localStorage.setItem('token', token);
                        window.localStorage.setItem('permissons', permissions);
                        window.localStorage.setItem('userType', typeUser);
                        window.localStorage.setItem('userName', userName);
                        window.localStorage.setItem('idType', result.data.data.idType);
                        window.location.href = '/';
                    }
                }else{
                    alert('Este usuario no tiene permisos para ingresar')
                }
            }else{
                this.setState({notification:true, email: '', password: ''});
            }
            this.setState({loading:false,  email: '', password: ''})
        });
    }

    render() {
        return (
            <div className="min-h-screen bg-gradient-to-br from-blue-950 via-blue-900 to-indigo-900 flex items-center justify-center px-4 sm:px-6 lg:px-8">
                {/* Elementos decorativos de fondo */}
                <div className="absolute inset-0 overflow-hidden">
                    <div className="absolute -top-40 -right-40 w-80 h-80 bg-blue-400 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"></div>
                    <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-indigo-400 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"></div>
                    <div className="absolute top-40 left-40 w-60 h-60 bg-purple-400 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"></div>
                </div>

                <div className="relative w-full max-w-md">
                    {/* Card principal */}
                    <div className="bg-white/95 backdrop-blur-sm rounded-3xl shadow-2xl p-8 border border-white/20">
                        {/* Header con logo y título */}
                        <div className="text-center mb-8">
                            <div className="mx-auto w-20 h-20 bg-gradient-to-br from-blue-950 to-indigo-900 rounded-2xl flex items-center justify-center mb-6 shadow-lg">
                                <BuildingOffice2Icon className="w-10 h-10 text-white" />
                            </div>
                            <h1 className="text-3xl font-bold text-gray-900 mb-2">Sistema administrativo</h1>
                            <p className="text-gray-600">Version 1.0.3</p>
                            <div className="flex items-center justify-center mt-4">
                                <ShieldCheckIcon className="w-5 h-5 text-green-600 mr-2" />
                                <span className="text-sm text-gray-500">Acceso Seguro</span>
                            </div>
                        </div>

                        {/* Formulario */}
                        <form className="space-y-6" onSubmit={(e) => { e.preventDefault(); this.login(); }}>
                            {/* Campo de usuario */}
                            <div>
                                <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                                    Nombre de Usuario
                                </label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <UserIcon className="h-5 w-5 text-gray-400" />
                                    </div>
                                    <input
                                        value={this.state.email}
                                        id="email"
                                        name="email"
                                        type="text"
                                        required
                                        autoComplete="username"
                                        placeholder="Ingresa tu usuario"
                                        className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-xl text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-950 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
                                        onChange={(event) => {this.setState({email: event.target.value})}}
                                    />
                                </div>
                            </div>

                            {/* Campo de contraseña */}
                            <div>
                                <label htmlFor="password" className="block text-sm font-semibold text-gray-700 mb-2">
                                    Contraseña
                                </label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <LockClosedIcon className="h-5 w-5 text-gray-400" />
                                    </div>
                                    <input
                                        value={this.state.password}
                                        id="password"
                                        name="password"
                                        type={this.state.showPassword ? "text" : "password"}
                                        required
                                        autoComplete="current-password"
                                        placeholder="Ingresa tu contraseña"
                                        className="block w-full pl-10 pr-12 py-3 border border-gray-300 rounded-xl text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-950 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
                                        onChange={(event) => {this.setState({password: event.target.value})}}
                                    />
                                    <button
                                        type="button"
                                        className="absolute inset-y-0 right-0 pr-3 flex items-center"
                                        onClick={() => this.setState({showPassword: !this.state.showPassword})}
                                    >
                                        {this.state.showPassword ? (
                                            <EyeSlashIcon className="h-5 w-5 text-gray-400 hover:text-gray-600" />
                                        ) : (
                                            <EyeIcon className="h-5 w-5 text-gray-400 hover:text-gray-600" />
                                        )}
                                    </button>
                                </div>
                            </div>

                            {/* Botón de login */}
                            <div className="pt-4">
                                {!this.state.loading ? (
                                    <button
                                        type="submit"
                                        disabled={!this.state.email || !this.state.password}
                                        className="w-full flex justify-center items-center py-3 px-4 border border-transparent rounded-xl shadow-lg text-base font-semibold text-white bg-gradient-to-r from-blue-950 to-indigo-900 hover:from-blue-900 hover:to-indigo-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-950 disabled:opacity-50 disabled:cursor-not-allowed transform hover:scale-105 transition-all duration-200"
                                    >
                                        <ShieldCheckIcon className="w-5 h-5 mr-2" />
                                        Iniciar Sesión
                                    </button>
                                ) : (
                                    <div className="w-full flex justify-center items-center py-3 px-4 rounded-xl bg-gray-100">
                                        <ClipLoader
                                            color="#1e3a8a"
                                            loading={true}
                                            size={24}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                        />
                                        <span className="ml-3 text-gray-600 font-medium">Verificando credenciales...</span>
                                    </div>
                                )}
                            </div>
                        </form>

                        {/* Footer */}
                        <div className="mt-8 pt-6 border-t border-gray-200">
                            <div className="text-center">
                                <p className="text-xs text-gray-500 mb-2">
                                    Sistema de Administración de Multas
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Indicadores de seguridad */}
                    <div className="mt-6 flex justify-center space-x-6 text-white/70">
                        <div className="flex items-center text-sm">
                            <div className="w-2 h-2 bg-green-400 rounded-full mr-2"></div>
                            <span>Conexión Segura</span>
                        </div>
                        <div className="flex items-center text-sm">
                            <div className="w-2 h-2 bg-blue-400 rounded-full mr-2"></div>
                            <span>Datos Protegidos</span>
                        </div>
                    </div>
                </div>

                {this.renderNotification()}
            </div>
        )
    }
}

export default Login;

